module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_09.f9509f38.gif";